var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentlenzLuminousWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 620,
    height: 300,
    viewBox: "0 0 620 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "dots",
    width: 12,
    height: 12,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1.3,
    fill: "#087CFF",
    fillOpacity: 0.42
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fade",
    x1: 0,
    y1: 250,
    x2: 610,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFFFFF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 220C94 132 172 131 258 180C345 230 442 170 620 52V300H0V220Z",
    fill: "url(#fade)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 620,
    height: 300,
    fill: "url(#dots)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12 238C86 128 173 128 264 181C355 234 459 158 637 32",
    stroke: "#087CFF",
    strokeOpacity: 0.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 260C98 151 180 151 269 198C365 249 476 169 632 64",
    stroke: "#FF2775",
    strokeOpacity: 0.18
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentlenzLuminousWave);
export default __webpack_public_path__ + "static/media/talentlenz-luminous-wave.4885c5d5b12b8735f4bb08a7688a6a91.svg";
export { ForwardRef as ReactComponent };